import { render } from "./EntityAttributeForms.vue?vue&type=template&id=21c00fdb&scoped=true"
import script from "./EntityAttributeForms.vue?vue&type=script&lang=js"
export * from "./EntityAttributeForms.vue?vue&type=script&lang=js"

import "./EntityAttributeForms.vue?vue&type=style&index=0&id=21c00fdb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21c00fdb"]])

export default __exports__